import BaseScopeCellContent from './BaseScopeCellContent'
import messageResource from '../../../../messageResource'

class ManageScopeCellContent extends BaseScopeCellContent {
    constructor() {
        super(null, {
            className: 'manageScopeContent',
        })

        this.state = {
            ...this.state,
            selectedScopeExists: false,
        }
    }

    _isScopeEmpty() {
        return !this.state.allScope && !this.state.selectedScopeExists
    }

    _getAllScopeMessage() {
        return messageResource.getMessage('user_list.table.manage_scope.entire_scope')
    }

    _getSelectedScopeMessage() {
        return messageResource.getMessage('user_list.table.manage_scope.part_scope')
    }

    _getNoAccessScopeMessage() {
        return messageResource.getMessage('user_list.table.manage_scope.no_access')
    }

    _getEmptyScopeMessage() {
        return messageResource.getMessage('user_list.table.manage_scope.not_selected')
    }

    _getEmptyNotAvailableScopeMessage() {
        return messageResource.getMessage('user_list.table.manage_scope.empty')
    }
}

export default ManageScopeCellContent



// WEBPACK FOOTER //
// ./web/js/administration/userManagement/userList/table/ManageScopeCellContent.js